import { z } from "zod";
import { qlikVariableSchema } from "./qlik-variables.js";
import { qlikDimensionSchema } from "./qlik-dimensions.js";
import { qlikMeasureSchema } from "./qlik-measures.js";
import { qlikFieldSchema } from "./qlik-fields.js";

export const qlikAppMetadataCacheSchema = z.object({
  id: z.string().uuid(),
  organizationId: z.string(),
  connectionId: z.string().uuid(),
  appId: z.string(),
  variables: z.array(qlikVariableSchema),
  dimensions: z.array(qlikDimensionSchema),
  measures: z.array(qlikMeasureSchema),
  fields: z.array(qlikFieldSchema),
  fetchedAt: z.string(),
});

export type QlikAppMetadataCache = z.infer<typeof qlikAppMetadataCacheSchema>;

export const qlikAppMetadataCacheResponseSchema = z.object({
  data: qlikAppMetadataCacheSchema,
});

export type QlikAppMetadataCacheResponse = z.infer<typeof qlikAppMetadataCacheResponseSchema>;

// GET response for the cache endpoint — data is null when no cache exists yet (normal state,
// not an error), which lets callers branch on absence without parsing an HTTP 404.
export const qlikAppMetadataCacheOptionalResponseSchema = z.object({
  data: qlikAppMetadataCacheSchema.nullable(),
});

export type QlikAppMetadataCacheOptionalResponse = z.infer<
  typeof qlikAppMetadataCacheOptionalResponseSchema
>;
